import React from "react";
import CommonMigration from "./CommonMigration";

const LabMigration = () => {
  const api = {
    check: "migration/lab/upload/",
    start: "migration/lab/upload/",
    progress: "migration/patient/upload/",
    download: "migration/patient/upload/",
  };

  return <CommonMigration moduleName="laboratory" api={api} />;
};

export default LabMigration;
